import React from 'react';
import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Drawer from '@material-ui/core/Drawer';
import { MaintenanceBanner } from '@shared/components';
import { SharedService } from '@consumers/services';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import OpenDrawerIcon from '@assets/icons/open-drawer.svg';
import CloseDrawerIcon from '@assets/icons/close-drawer.svg';
import PoweredIcon from '@assets/icons/powered-icon.png';
import useStyles from './style';

export default ({
  children = null,
  drawerList = [],
  isDrawerOpen = false,
  onDrawerToggle = () => {},
  headerContent = <></>,
  classes: passedClasses = {},
}) => {
  const [isOpen, setIsOpen] = React.useState(isDrawerOpen);
  const [maintenanceStartTime, setMaintenanceStartTime] = React.useState(null);
  const classes = useStyles({ isOpen, maintenanceStartTime });

  const handleDrawerToggle = () => {
    onDrawerToggle(!isOpen);
    setIsOpen(!isOpen);
  };

  const handleMaintenanceSlotChange = startTime => {
    setMaintenanceStartTime(startTime);
  };

  return (
    <div className={classes.root}>
      <AppBar
        position='fixed'
        className={clsx(classes.appBar, passedClasses.appBar)}
      >
        <MaintenanceBanner
          getMaintenanceSlot={SharedService.getMaintenanceSlot}
          handleMaintenanceSlotChange={handleMaintenanceSlotChange}
        />
        <Toolbar>{headerContent}</Toolbar>
      </AppBar>
      <Drawer
        variant='permanent'
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: isOpen,
          [classes.drawerClose]: !isOpen,
        })}
        classes={{
          paper: clsx({
            [classes.drawerOpen]: isOpen,
            [classes.drawerClose]: !isOpen,
          }),
        }}
      >
        <List
          className={clsx(classes.toolbarSpacing, passedClasses.drawerList)}
        >
          <ListItem key='drawer-toggler' className='f-justify-center'>
            <IconButton size='small' onClick={handleDrawerToggle}>
              <Paper elevation={2}>
                <div
                  className={classes.drawerIcon}
                  style={{
                    backgroundImage: `url(${
                      isOpen ? CloseDrawerIcon : OpenDrawerIcon
                    })`,
                  }}
                />
              </Paper>
            </IconButton>
          </ListItem>
          {drawerList.map((listItem, index) => {
            let content = listItem.render || null;
            if (!content) {
              content = (
                <>
                  <ListItemIcon
                    className={clsx(
                      classes.listItemIcon,
                      passedClasses.drawerListItem,
                      {
                        'f-justify-center': !isOpen,
                      }
                    )}
                  >
                    <img
                      alt=''
                      src={listItem.icon}
                      className='sidebar-list-icon'
                    />
                    <img
                      alt=''
                      src={listItem.activeIcon}
                      className='sidebar-list-active-icon'
                    />
                  </ListItemIcon>
                  <ListItemText
                    className={clsx(
                      classes.fadeOutElement,
                      passedClasses.listItemText
                    )}
                    primary={listItem.label}
                  />
                </>
              );
            }
            return (
              <>
                {isOpen ? (
                  <ListItem
                    component={NavLink}
                    activeClassName={classes.activeListItem}
                    to={listItem.to}
                    key={`drawer-list-item-${listItem.to || index}`}
                    className={clsx(classes.listItem, {
                      'c-default': listItem.canNavigateTo
                        ? !listItem.canNavigateTo()
                        : false,
                    })}
                  >
                    {content}
                  </ListItem>
                ) : (
                  <Tooltip title={listItem.label} placement='top-start'>
                    <ListItem
                      component={NavLink}
                      activeClassName={classes.activeListItem}
                      to={listItem.to}
                      key={`drawer-list-item-${listItem.to || index}`}
                      className={clsx(classes.listItem, {
                        'c-default': listItem.canNavigateTo
                          ? !listItem.canNavigateTo()
                          : false,
                      })}
                    >
                      {content}
                    </ListItem>
                  </Tooltip>
                )}
              </>
            );
          })}
        </List>
        <div className={classes.poweredBy}>
          <p className={classes.fadeOutElement}>Powered by</p>
          <img alt='Powered by brand icon' src={PoweredIcon} />
          <div className={classes.fadeOutElement}>
            Professional
            <br /> Services
          </div>
        </div>
      </Drawer>
      <div className={clsx(classes.toolbarSpacing, classes.contentContainer)}>
        {children}
      </div>
    </div>
  );
};
